export default "__VITE_ASSET__BQSk4F12__"